import LearningAgreementPage from "./LearningAgreementPage";

export default LearningAgreementPage;